import "core-js/modules/es.array.map.js";
import React from 'react';
import PropTypes from 'prop-types';
import { _NotesListingWrapper } from "./styles";
import Note from "../Note";
import { _FadeTransition } from "../../style";
var NotesListing = function NotesListing(_ref) {
  var notes = _ref.notes,
    searchParameters = _ref.searchParameters;
  return /*#__PURE__*/React.createElement(_NotesListingWrapper, null, /*#__PURE__*/React.createElement("div", {
    id: "NotesListingContainer"
  }, notes && notes.map(function (note) {
    return /*#__PURE__*/React.createElement(_FadeTransition, {
      key: note.id
    }, /*#__PURE__*/React.createElement(Note, {
      key: "note-container-".concat(note.id),
      note: note,
      searchParameters: searchParameters
    }));
  })));
};
NotesListing.propTypes = {
  notes: PropTypes.array
};
export default NotesListing;